var internet = {};
module['exports'] = internet;
internet.domain_suffix = require("./domain_suffix");



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/sv/internet/index.js
// module id = 2748
// module chunks = 2